
import React from "react";
import { FileText, Calculator, HelpCircle, Info, Users, List, MessageCircle, Home } from "lucide-react";

// Popular nursing home counties and locations
export const popularLocations = [
  { title: "Dublin", path: "/nursing-homes/dublin" },
  { title: "Cork", path: "/nursing-homes/cork" },
  { title: "Limerick", path: "/nursing-homes/limerick" },
  { title: "Galway", path: "/nursing-homes/galway" },
];

export const otherLocations = [
  { title: "Donegal", path: "/nursing-homes/donegal" },
  { title: "Kildare", path: "/nursing-homes/kildare" },
  { title: "Meath", path: "/nursing-homes/meath" },
  { title: "Wicklow", path: "/nursing-homes/wicklow" },
];

// Resource items
export const resourceItems = [
  {
    title: "Home Care Providers",
    path: "/home-care",
    description: "Find and compare home care providers across Ireland.",
    icon: <Home size={18} />,
  },
  {
    title: "Care Advisor",
    path: "/consultations",
    description: "Get free, instant guidance from our AI Care Advisor.",
    icon: <MessageCircle size={18} />,
  },
  {
    title: "Blog",
    path: "/blog",
    description: "Learn more about elderly care services on our blog.",
    icon: <FileText size={18} />,
  },
  {
    title: "Fair Deal Calculator",
    path: "/fair-deal-calculator",
    description: "Calculate an estimate of your nursing home contributions.",
    icon: <Calculator size={18} />,
  },
  {
    title: "Guides",
    path: "/guides",
    description: "Support us by purchasing our guides to finding a nursing home faster.",
    icon: <HelpCircle size={18} />,
  },
];

export const companyItems = [
  {
    title: "About us",
    path: "/about",
    description: "Learn about our story and our mission statement.",
    icon: <Info size={18} />,
  },
  {
    title: "Press",
    path: "/press",
    description: "News and writings, press releases, and press resources.",
    icon: <FileText size={18} />,
  },
  {
    title: "Careers",
    path: "/careers",
    description: "Nursing Homes are always hiring. Register your interest and submit your CV.",
    icon: <Users size={18} />,
  },
  {
    title: "Legal",
    path: "/legal/terms-of-use",
    description: "Terms of use, privacy policy, and cookie policy.",
    icon: <List size={18} />,
  },
];
